<mat-form-field [formGroup]="group" class="input" appearance="outline">
  <mat-label>{{ config.label }}</mat-label>
  <input
    type="time"
    matInput
    class="uppercase"
    [formControlName]="config.name"
    [disabled]="!!config.disabled"
  />
</mat-form-field>
